/**
 * Agent configuration for the Ask Navi stateless copilot agent.
 * Lives in this lib only — swap values when CI-5476 delivers the production agent ARN/payload.
 */
export const ASK_NAVI_AGENT_CONFIG = {
  namespaceId: 'brightnav',
  agentId: 'content',
  agentAliasId: 'default',
  agentFramework: 'agentcore_strands' as const,
  agentcoreRuntimeName: 'BsbStrandsRuntime',
};

/** Metadata shape stored on Ask Navi conversations (`conversation/list` items). */
export const ASK_NAVI_CONVERSATION_METADATA = {
  namespace_id: ASK_NAVI_AGENT_CONFIG.namespaceId,
  agent_id: ASK_NAVI_AGENT_CONFIG.agentId,
  agent_alias_id: ASK_NAVI_AGENT_CONFIG.agentAliasId,
  agent_framework: ASK_NAVI_AGENT_CONFIG.agentFramework,
};
